import splitClassTokens from './split-class-tokens';
import parsePrefixedClassToken from './parse-prefixed-class-token';

const findClassToken = (classString, { prefix = null, matchesToken }) => {
  const found = splitClassTokens(classString)
    .map(parsePrefixedClassToken)
    .find((parsed) => parsed.prefix === prefix && matchesToken(parsed.token));

  return found ? found.token : null;
};

export default findClassToken;
